var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-bar-item',{attrs:{"title":_vm.time,"toptitle":_vm.toptitle,"icon":"clock"}})
}
var staticRenderFns = []

export { render, staticRenderFns }